import ConnectThirdPartyClient from "./ConnectThirdPartyClient";
import ConnectThirdPartyServer from "./ConnectThirdPartyServer";

export default {
  Client: ConnectThirdPartyClient,
  Server: ConnectThirdPartyServer,
}
